module.exports = __webpack_public_path__ + "static/media/224-portugal.5b3a556c.svg";